import { ArsTableBody, ArsTableRow, LoadFunctionWithData } from "aic";
import axios from "axios";
import { IEditorV3 } from "editor-v3";
import { processAxiosError } from "../processAxiosError";

/**
 * Fetches ARS table calculation results based on the provided ARS table body parameters.
 *
 * @param backEndUrl - Base backend URL
 * @param params - ARS table body including IDs, columns, rows and row headers
 * @param controller - AbortController to cancel the request if needed
 * @returns A promise that resolves to the ARS table calculation results or an error
 */
export const getArsTableCalculation: LoadFunctionWithData<
  ArsTableBody<IEditorV3>,
  ArsTableRow<IEditorV3>[]
> = async (backEndUrl: string, params: ArsTableBody<IEditorV3>, controller: AbortController) => {
  try {
    const url = `${backEndUrl}Ars/ArsTableCalculation`;

    const response = await axios.post(url, params, {
      signal: controller.signal,
    });

    return { success: true, data: response.data };
  } catch (error) {
    return processAxiosError(
      "Get ARS table calculation failed - please refresh the page and try again",
      error,
    );
  }
};
